import { createRoot } from "react-dom/client";
import "@/assets/css/main.css";
import App from "@/App";
import AuthStart from "@/pages/Auth/AuthStart";
import AuthEnd from "@/pages/Auth/AuthEnd";
import ErrorBoundary from "@/components/ErrorBoundary/ErrorBoundary";
import { initTelemetry, reportTelemetryError } from "@/core/telemetry";
import "@/locales";

initTelemetry();

const getAppComponent = () => {
  const path = window.location.pathname;
  if (path === "/auth-start") return <AuthStart />;
  if (path === "/auth-end") return <AuthEnd />;
  return <App />;
};

const container = document.getElementById("root");
const root = createRoot(container!, {
  onCaughtError: (error, errorInfo) =>
    reportTelemetryError(error, {
      scope: "ErrorBoundary",
      componentStack: errorInfo.componentStack,
    }),
});
root.render(<ErrorBoundary>{getAppComponent()}</ErrorBoundary>);
